import * as React from 'react'
import './load.css'
const Loading = () => {
    return <div className="loader"></div>
}
export default Loading;